import { createContext, useContext } from "react";
import { ChatSession, Message } from "../interfaces/Chat";
import { Persona } from "../api/Persona";

interface ChatSessionsContextType {
  chatSessions: ChatSession[];
  updateSelectedChatSession: (chatSessionId: string) => void;
  addNewChatSession: (question?: string) => string;
  promoteChatSession: (chatId: string, personaId?: string) => void;
  updateNewChatSession: (question: string) => void;
  resetSelectedChatSession: () => void;
  hideChatSession: (chatId: string) => void;
  setChatSessions: any;
  selectedChatSession: string | null | undefined;
  messages: Message[];
  allMessages: Record<string, Message[]>;
  setMessages: (messages: Message[] | ((prev: Message[]) => Message[]), chatId?: string) => void;
  noMsgReset: React.MutableRefObject<boolean>;
  filterFromYear: number | null;
  setFilterFromYear: (year: number | null) => void;
  filterToYear: number | null;
  setFilterToYear: (year: number | null) => void;
  mobileOpen: boolean;
  handleDrawerToggle: () => void;
  handleDrawerTransitionEnd: () => void;
  handleDrawerClose: () => void;
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
  persona: Persona | undefined;
  updatePersona: (persona: Persona | undefined) => void
}

const ChatSessionsContext = createContext<ChatSessionsContextType | undefined>(
  undefined
);

export function useChatSessionsContext() {
  const context = useContext(ChatSessionsContext);
  if (context === undefined) {
    throw new Error();
  }
  return context;
}

export default ChatSessionsContext;
